/**
 * Animation Utilities
 * Spring physics presets and micro-interaction configurations for Framer Motion
 */

// Spring physics presets
export const springs = {
  gentle: {
    type: 'spring',
    stiffness: 200,
    damping: 20,
  },
  bouncy: {
    type: 'spring',
    stiffness: 400,
    damping: 17,
  },
  snappy: {
    type: 'spring',
    stiffness: 500,
    damping: 30,
  },
  slow: {
    type: 'spring',
    stiffness: 100,
    damping: 15,
  },
};

// Micro-interaction animations
export const microInteractions = {
  buttonPress: {
    whileTap: { scale: 0.95 },
    whileHover: { scale: 1.02 },
    transition: springs.bouncy,
  },
  buttonPop: {
    whileTap: { scale: [1, 0.95, 1.05, 1] },
    transition: { duration: 0.3 },
  },
  cardHover: {
    whileHover: {
      y: -4,
      transition: springs.gentle,
    },
    transition: springs.gentle,
  },
  checkboxPop: {
    initial: { scale: 0.8, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.8, opacity: 0 },
    transition: springs.bouncy,
  },
  slideUp: {
    initial: { y: 20, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: 20, opacity: 0 },
    transition: springs.gentle,
  },
  slideDown: {
    initial: { y: -20, opacity: 0 },
    animate: { y: 0, opacity: 1 },
    exit: { y: -20, opacity: 0 },
    transition: springs.gentle,
  },
  scaleIn: {
    initial: { scale: 0.95, opacity: 0 },
    animate: { scale: 1, opacity: 1 },
    exit: { scale: 0.95, opacity: 0 },
    transition: springs.gentle,
  },
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: { duration: 0.2 },
  },
};

// Page transition variants
export const pageTransitions = {
  fade: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
    transition: springs.gentle,
  },
  slideFromRight: {
    initial: { x: 20, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: -20, opacity: 0 },
    transition: springs.gentle,
  },
  slideFromBottom: {
    initial: { y: '100%' },
    animate: { y: 0 },
    exit: { y: '100%' },
    transition: springs.gentle,
  },
};

// Stagger children animation
export const staggerChildren = {
  animate: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};

// Shared element transition config
export const sharedElement = {
  layoutId: 'shared-element',
  transition: springs.gentle,
};

// Drag constraints
export const dragConstraints = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};
